'use client';

import ProductAndCategory from '@/joystagram-components/components/consumer/product-and-category';

export default function ProductAndCategoryClient({
  productOptionsPromise,
  productHeroImagePromise,
  category,
  slug,
}) {
  return (
    <ProductAndCategory
      productOptionsPromise={productOptionsPromise}
      productHeroImagePromise={productHeroImagePromise}
      category={category}
      slug={slug}
    />
  );
}
